import { ThemeOptions } from '@mui/material/styles';

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'ProximaNova, sans-serif',
  h1: {
    fontWeight: 600,
    fontSize: '35px',
    lineHeight: 1.56,
  },
  h2: {
    fontWeight: 600,
    fontSize: '30px',
    lineHeight: 1.56,
  },
  h3: {
    fontWeight: 600,
    fontSize: '26px',
    lineHeight: 1.56,
  },
  h4: {
    fontWeight: 600,
    fontSize: '22px',
    lineHeight: 1.56,
  },
  h5: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: 1.56,
  },
  h6: {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 1.56,
  },
  subtitle1: {
    fontSize: '16px',
    lineHeight: 1.56,
    fontWeight: 400,
  },
  subtitle2: {
    fontSize: '14px',
    lineHeight: 1.56,
    fontWeight: 400,
  },
  body1: {
    fontSize: '14px',
    lineHeight: 1.56,
    color: '#141F2B',
  },
  body2: {
    fontSize: '12px',
    lineHeight: 1.56,
  },
  button: {
    fontSize: '14px',
    textTransform: 'none',
    fontWeight: 400,
  },
  caption: {
    fontSize: '12px',
    lineHeight: 1.56,
  },
  overline: {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
    lineHeight: 1.56,
  },
};

export default typography;